define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../utils/stringUtils", "../../utils/kendoUtils", "../../models/NumberImportModel"], function (require, exports, $, ko, log, tools, stringUtils, KendoUtils, NumberImportModel) {
    "use strict";
    var Import = /** @class */ (function () {
        function Import() {
            this.editModel = ko.observable(new NumberImportModel());
            this.resulModel = ko.observable();
            this.hasResults = ko.observable(false);
            this.importFinished = ko.observable(false);
            this.officeLocations = [];
            this.lastError = "";
            this.isImportValid = false;
            this.bvnProviderId = 0;
            this.filteredStatuses = ko.observableArray([]);
            this.importData = [];
        }
        Import.prototype.init = function () {
        };
        Import.prototype.importPhoneNumbers = function (callback) {
            var self = this;
            self.resulModel = ko.observable();
            self.hasResults(false);
            self.importFinished(false);
            tools.editModal({
                title: "Phone Numbers Import",
                buttonTitle: "Import",
                modalClass: "full-width",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (self.importData.length <= 0) {
                        tools.error("Data is empty");
                        return;
                    }
                    self.validateAllRecords();
                    if (!self.isImportValid) {
                        tools.error(self.lastError ? self.lastError : "Some of import records are not valid");
                        return;
                    }
                    $(event.currentTarget).button('loading');
                    self.processNumbersImport(event.currentTarget, modal, callback);
                },
                opened: function (modal) {
                    self.importData = [];
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: "/Import/LookupData",
                        data: { customerId: self.editModel().CustomerId() },
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                                self.officeLocations = data.Data.lookupLists.OfficeLocations;
                                self.bvnProviderId = self.lookupLists.BvnProviderId;
                                self.filteredStatuses(ko.utils.arrayFilter(data.Data.lookupLists.PhoneStatuses, function (item) {
                                    if (self.editModel().CustomerId() > 0) {
                                        return item.Text !== "Available" && item.Text !== "On Hold" && item.Text !== "Ported Out";
                                    }
                                    else {
                                        return item.Text !== "On Hold" && item.Text !== "Ported Out";
                                    }
                                }));
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getLookupData).done(function (lookupData, data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'number-import-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        $("#CustomerName", modal).autocomplete({
                            source: function (request, response) {
                                tools.ajaxPost({
                                    url: "/Customers/findCustomerByName",
                                    data: { Name: self.editModel().CustomerName() },
                                    success: function (Results) {
                                        response($.map(Results.Data, function (item) {
                                            return {
                                                label: item.Name,
                                                value: item.Id,
                                                OfficeLocations: item.OfficeLocations
                                            };
                                        }));
                                    }
                                });
                            },
                            change: function (event, ui) {
                                if (!ui.item) {
                                    self.editModel().CustomerId(0);
                                }
                                //log.log(event);
                            },
                            select: function (event, ui) {
                                var selectedObj = ui.item;
                                self.editModel().CustomerId(selectedObj.value);
                                self.officeLocations = selectedObj.OfficeLocations;
                                self.updateLocationsListData();
                                setTimeout(function () {
                                    self.validateAllRecords();
                                });
                                return false;
                            },
                            focus: function (event, ui) {
                                this.value = ui.item.label;
                                event.preventDefault(); // Prevent the default focus behavior.
                            },
                            open: function (event, ui) {
                                $(this).autocomplete("widget").css("z-index", 1060);
                                $(this).keydown(function (event) {
                                    if (event.keyCode === 13) {
                                        $(".ui-menu-item:first a").click();
                                    }
                                });
                            }
                        });
                        self.fileUpload = $("#fileupload", modal).kendoUpload({
                            async: {
                                saveUrl: "/Import/UploadImportPreviewFile",
                                autoUpload: true
                            },
                            select: function (e) {
                                $(e.sender.element).parents(".k-upload").find(".k-upload-files").remove();
                            },
                            complete: function (e) {
                                log.log(e);
                            },
                            success: function (e) {
                                var result = e.response;
                                if (result.Success) {
                                    self.importData = result.Data;
                                    self.validateAllRecords();
                                }
                                else {
                                    tools.error(result.Error);
                                }
                                log.log(e);
                            }
                        });
                        self.editModel().CustomerId.subscribe(function () {
                            self.filteredStatuses(ko.utils.arrayFilter(self.lookupLists.PhoneStatuses, function (item) {
                                if (self.editModel().CustomerId() > 0) {
                                    return item.Text !== "Available" && item.Text !== "On Hold" && item.Text !== "Ported Out";
                                }
                                else {
                                    return item.Text !== "On Hold" && item.Text !== "Ported Out";
                                }
                            }));
                            self.statusesDropdown.setDataSource({
                                data: self.filteredStatuses()
                            });
                        });
                        self.editModel().CreateStatusIfNotExist.subscribe(function () {
                            self.validateAllRecords();
                        });
                        self.editModel().CreateProviderIfNotExist.subscribe(function () {
                            self.validateAllRecords();
                        });
                        self.editModel().CreateOfficeLocationIfNotExist.subscribe(function () {
                            self.validateAllRecords();
                        });
                        self.editModel().CreateTypeIfNotExist.subscribe(function () {
                            self.validateAllRecords();
                        });
                        self.initImportPhonesGrid(self.lookupLists.GridStructures.PhoneNumbersImportList);
                    });
                }
            });
        };
        Import.prototype.initImportPhonesGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            self.addEditActionColumn(columns);
            self.importPhoneNumbersTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    //data: self.importData,
                    transport: {
                        read: function (options) {
                            options.success(self.importData);
                        },
                        create: function (options) {
                            self.importData.push(options.data);
                            options.success(options.data);
                        },
                        update: function (options) {
                            var dataItem = ko.utils.arrayFirst(self.importData, function (item) {
                                return item.Id === options.data.Id;
                            });
                            if (dataItem) {
                                $.extend(dataItem, options.data);
                            }
                            options.success(options.data);
                        },
                        destroy: function (options) {
                            var dataRow = ko.utils.arrayFirst(self.importData, function (item) { return item.Id === options.data.Id; });
                            ko.utils.arrayRemoveItem(self.importData, dataRow);
                            options.success(options.data);
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: "",
                        total: function (result) {
                            result = result.data || result;
                            return result.length || 0;
                        }
                    },
                    serverFiltering: false,
                    serverPaging: false,
                    serverSorting: false
                },
                gridOptions: {
                    toolbar: kendo.template($("#number-import-toolbar").html()),
                    height: 500,
                    columns: columns,
                    dataBound: function (e) {
                        var dataItems = e.sender.dataSource.view();
                        for (var j = 0; j < dataItems.length; j++) {
                            var error = dataItems[j].get("Error");
                            if (error) {
                                console.error(error);
                                var row = e.sender.tbody.find("[data-kendo-uid='" + dataItems[j].uid + "']");
                                row.addClass("alert-danger");
                            }
                        }
                    },
                    editable: {
                        mode: "inline"
                    },
                    save: function (e) {
                        self.validateOneRecord(e.model);
                        setTimeout(function () {
                            e.sender.saveChanges();
                        }, 100);
                    },
                    remove: function (e) {
                        setTimeout(function () {
                            e.sender.saveChanges();
                        }, 100);
                    }
                },
                gridId: "importPreviewTable",
                enableExport: {
                    entityName: "PhoneNumber",
                    title: "Phone Numbers",
                    enablePdf: false
                }
            };
            self.importPhoneNumbersTable.initGrid(gridOptions);
            setTimeout(function () {
                self.updateBulkHeader();
                self.importPhoneNumbersTable.refresh();
            });
            $("#importPreviewTable .btn-clear-rows").on("click", function (event) {
                var r = confirm("Are you sure you want to remove all rows");
                if (r) {
                    self.importData = [];
                    self.importPhoneNumbersTable.refresh();
                }
            });
            $("#importPreviewTable .btn-export").on("click", function (event) {
                var gridData = self.importPhoneNumbersTable.getGridData();
                gridData.saveAsExcel();
                event.preventDefault();
            });
            $("#importPreviewTable .k-grid-content").on("click", ".btn-remove", function (event) {
                KendoUtils.KendoUtils.removeGridRow(this);
                event.preventDefault();
            }).on("paste", function (event) {
                var pastedText = undefined;
                if (window["clipboardData"] && window["clipboardData"].getData) { // IE
                    pastedText = window["clipboardData"].getData("Text");
                }
                else if (event.originalEvent["clipboardData"] && event.originalEvent["clipboardData"].getData) {
                    pastedText = event.originalEvent["clipboardData"].getData("text/plain");
                }
                setTimeout(function () {
                    // the the pasted content
                    var value = $.trim(pastedText);
                    // get the pasted rows - split the text by new line
                    var rows = value.split("\n");
                    var maxId = 0;
                    ko.utils.arrayForEach(self.importData, function (item) {
                        maxId = item.Id > maxId ? item.Id : maxId;
                    });
                    maxId++;
                    for (var i = 0; i < rows.length; i++) {
                        // get the cells - split by tab
                        var cells = rows[i].split("\t");
                        self.addNewRecord({
                            Id: maxId++,
                            Number: cells[0],
                            Status: cells[1] || '',
                            Provider: cells[2] || '',
                            PhoneType: cells[3] || '',
                            BTN: cells[4] || '',
                            Comment: cells[5] || '',
                            OfficeAddress: cells[6] || ''
                        });
                    }
                    self.importPhoneNumbersTable.refresh();
                });
                return false; // Prevent the default handler from running.
            });
        };
        Import.prototype.updateBulkHeader = function () {
            var self = this;
            var dataGrid = self.importPhoneNumbersTable.getGridData();
            dataGrid.element.find(".bulkActionsHeader").remove();
            var item = dataGrid._headerCells().clone();
            item.attr("data-uid", "");
            item.attr("data-role", "");
            item.data("id", "");
            var cells = item;
            $(cells.get(0)).html('<div class="input-group"><span class="input-group-addon"><input type="checkbox"/></span><input type="text" class="k-input k-textbox" disabled="disabled" name="Number"></div>');
            $(cells.get(1)).html('<div class="input-group"><span class="input-group-addon"><input type="checkbox"/></span><input type="text" disabled="disabled" name="Status"></div>');
            $(cells.get(2)).html('<div class="input-group"><span class="input-group-addon"><input type="checkbox"/></span><input type="text" disabled="disabled" name="Provider"></div>');
            $(cells.get(3)).html('<div class="input-group"><span class="input-group-addon"><input type="checkbox"/></span><input type="text" disabled="disabled" name="PhoneType"></div>');
            $(cells.get(4)).html('<div class="input-group"><span class="input-group-addon"><input type="checkbox"/></span><input type="text" class="k-input k-textbox" disabled="disabled" name="BTN"></div>');
            $(cells.get(5)).html('<div class="input-group"><span class="input-group-addon"><input type="checkbox"/></span><input type="text" class="k-input k-textbox" disabled="disabled" name="Comment"></div>');
            $(cells.get(6)).html('<div class="input-group"><span class="input-group-addon"><input type="checkbox"/></span><input type="text" disabled="disabled" name="OfficeAddress"></div>');
            $(cells.get(7)).html('<button type="button" class="btn btn-sm btn-primary btn-bulk btn-info" data-loading-text="Working...">Apply</button>');
            item.addClass("bulkActionsHeader");
            var thead = dataGrid.element.find(".k-grid-header table thead");
            thead.append(item);
            //append actions
            $(".bulkActionsHeader", dataGrid.element).on("click", ".btn-bulk", function (e) {
                $(event.currentTarget).button("loading");
                var selectedElements = $("input:checkbox:checked", dataGrid.element).parent().parent();
                var values = [];
                var numberValueObject = null;
                for (var i = 0; i < selectedElements.length; i++) {
                    var oneValue = {
                        name: "",
                        value: ""
                    };
                    var inputElements = $(selectedElements[i]).find('input[type="text"]');
                    var dropdown;
                    if (inputElements.length > 1) {
                        dropdown = $(inputElements[1]).data("kendoComboBox");
                        if (dropdown) {
                            oneValue.name = $(inputElements[1]).attr("name");
                            oneValue.value = dropdown.value();
                        }
                    }
                    else {
                        oneValue.name = $(inputElements[0]).attr("name");
                        oneValue.value = $(inputElements[0]).val();
                    }
                    if (oneValue.name === "Number") {
                        numberValueObject = oneValue;
                    }
                    values.push(oneValue);
                }
                if (numberValueObject) { //add new DID's
                    var numbers = numberValueObject.value.split(";");
                    var maxId = 0;
                    ko.utils.arrayForEach(self.importData, function (dataItem) {
                        maxId = dataItem.Id > maxId ? dataItem.Id : maxId;
                    });
                    var newDataItem = {
                        Id: maxId++,
                        Number: undefined,
                        Status: undefined,
                        Provider: undefined,
                        PhoneType: undefined,
                        BTN: undefined,
                        Comment: undefined,
                        OfficeAddress: undefined
                    };
                    ko.utils.arrayForEach(values, function (valueItem) {
                        newDataItem[valueItem.name] = valueItem.value;
                    });
                    ko.utils.arrayForEach(numbers, function (oneNumber) {
                        var newNumbers = [];
                        var j;
                        var numberprefix;
                        if (stringUtils.endsWith(oneNumber, "XXX")) {
                            numberprefix = oneNumber.trim().replace("XXX", "");
                            for (j = 0; j < 1000; j++) {
                                newNumbers.push(numberprefix + stringUtils.pad(j, 2) + "");
                            }
                        }
                        else if (stringUtils.endsWith(oneNumber, "XX")) {
                            numberprefix = oneNumber.trim().replace("XX", "");
                            for (j = 0; j < 100; j++) {
                                newNumbers.push(numberprefix + stringUtils.pad(j, 1) + "");
                            }
                        }
                        else if (stringUtils.endsWith(oneNumber, "X")) {
                            numberprefix = oneNumber.trim().replace("X", "");
                            for (j = 0; j < 10; j++) {
                                newNumbers.push(numberprefix + j + "");
                            }
                        }
                        else if (stringUtils.contains(oneNumber, "-")) {
                            var rangeNumbersStr = oneNumber.split("-");
                            var startNumberStr = rangeNumbersStr[0].trim();
                            var endNumberStr = rangeNumbersStr[1].trim();
                            if (!$.isNumeric(startNumberStr)) {
                                tools.error("First Phone Number Is Not A Number");
                                return;
                            }
                            if (!$.isNumeric(endNumberStr)) {
                                tools.error("Last Phone Number Is Not A Number");
                                return;
                            }
                            var startNumber = +startNumberStr;
                            var endNumber = +endNumberStr;
                            if (startNumber > endNumber) {
                                tools.error("First Phone Number Is Bigger Then Last Number");
                                return;
                            }
                            var count = endNumber - startNumber + 1;
                            if (count > 10000) {
                                tools.error("Max allowed import number is 9999");
                                return;
                            }
                            for (j = 0; j < count; j++) {
                                var newNumber = startNumber++;
                                newNumbers.push(newNumber + "");
                            }
                        }
                        else {
                            newNumbers.push(oneNumber.trim());
                        }
                        ko.utils.arrayForEach(newNumbers, function (realNumber) {
                            var newRecord = $.extend({}, newDataItem, true);
                            newRecord.Id = maxId++;
                            newRecord.Number = realNumber;
                            self.addNewRecord(newRecord);
                        });
                    });
                }
                else { //Update all values
                    ko.utils.arrayForEach(self.importData, function (dataItem) {
                        ko.utils.arrayForEach(values, function (valueItem) {
                            dataItem[valueItem.name] = valueItem.value;
                        });
                        self.validateOneRecord(dataItem);
                    });
                }
                dataGrid.dataSource.read();
                $(event.currentTarget).button("reset");
            }).on("click", 'input[type="checkbox"]', function (e) {
                var element = $(e.currentTarget);
                var inputElement = element.parent().parent().find('input[type="text"]');
                var value = element.is(":checked");
                var dropdown;
                if (inputElement.length > 1) {
                    dropdown = $(inputElement[1]).data("kendoComboBox");
                    if (dropdown) {
                        dropdown.enable(value);
                    }
                }
                else {
                    if (value) {
                        inputElement.removeAttr("disabled");
                    }
                    else {
                        inputElement.attr("disabled", "disabled");
                    }
                }
            });
            self.statusesDropdown = $('.bulkActionsHeader input[name="Status"]', dataGrid.element)
                .kendoComboBox({
                dataTextField: "Text",
                dataValueField: "Text",
                filter: "contains",
                autoBind: true,
                minLength: 1,
                dataSource: {
                    data: self.filteredStatuses()
                }
            }).data("kendoComboBox");
            $('.bulkActionsHeader input[name="Provider"]', dataGrid.element)
                .kendoComboBox({
                dataTextField: "Text",
                dataValueField: "Text",
                filter: "contains",
                autoBind: true,
                minLength: 1,
                dataSource: {
                    data: self.lookupLists.PhoneProviders
                }
            }).data("kendoComboBox");
            $('.bulkActionsHeader input[name="PhoneType"]', dataGrid.element)
                .kendoComboBox({
                dataTextField: "Text",
                dataValueField: "Text",
                filter: "contains",
                autoBind: true,
                minLength: 1,
                dataSource: {
                    data: self.lookupLists.PhoneTypes
                }
            }).data("kendoComboBox");
            $('.bulkActionsHeader input[name="OfficeAddress"]', dataGrid.element)
                .kendoComboBox({
                dataTextField: "Text",
                dataValueField: "Text",
                filter: "contains",
                autoBind: true,
                minLength: 1,
                dataSource: {
                    data: self.officeLocations
                }
            }).data("kendoComboBox");
        };
        Import.prototype.addEditActionColumn = function (columns) {
            var self = this;
            var actions = {
                field: "",
                command: ["edit", "destroy"],
                width: "86px"
            };
            columns.push(actions);
            //check custom editor
            var customEditors = {};
            customEditors["StatusEditor"] = function (container, options) {
                $('<input data-bind="value:' + options.field + '" name="' + options.field + '"/>')
                    .appendTo(container)
                    .kendoComboBox({
                    dataTextField: "Text",
                    dataValueField: "Text",
                    filter: "contains",
                    autoBind: true,
                    minLength: 1,
                    dataSource: {
                        data: self.filteredStatuses()
                    }
                }).data("kendoComboBox");
            };
            customEditors["ProviderEditor"] = function (container, options) {
                $('<input data-bind="value:' + options.field + '" name="' + options.field + '"/>')
                    .appendTo(container)
                    .kendoComboBox({
                    dataTextField: "Text",
                    dataValueField: "Text",
                    filter: "contains",
                    autoBind: true,
                    minLength: 1,
                    dataSource: {
                        data: self.lookupLists.PhoneProviders
                    }
                }).data("kendoComboBox");
            };
            customEditors["TypeEditor"] = function (container, options) {
                $('<input data-bind="value:' + options.field + '" name="' + options.field + '"/>')
                    .appendTo(container)
                    .kendoComboBox({
                    dataTextField: "Text",
                    dataValueField: "Text",
                    filter: "contains",
                    autoBind: true,
                    minLength: 1,
                    dataSource: {
                        data: self.lookupLists.PhoneTypes
                    }
                }).data("kendoComboBox");
            };
            ko.utils.arrayForEach(columns, function (column) {
                if (column.hasOwnProperty("editor")) {
                    column["editor"] = customEditors[column["editor"]];
                }
            });
            return columns;
        };
        Import.prototype.updateLocationsListData = function () {
            var self = this;
            var dataGrid = self.importPhoneNumbersTable.getGridData();
            var addressDropdown = $('.bulkActionsHeader input[name="OfficeAddress"]', dataGrid.element).data("kendoComboBox");
            var dataSource = new kendo.data.DataSource({
                data: self.officeLocations
            });
            addressDropdown.setDataSource(dataSource);
        };
        Import.prototype.validateAllRecords = function () {
            var self = this;
            var dataGrid = self.importPhoneNumbersTable.getGridData();
            self.isImportValid = true;
            ko.utils.arrayForEach(self.importData, function (item) {
                if (!self.validateOneRecord(item)) {
                    self.isImportValid = false;
                    self.lastError = item.Error;
                }
            });
            dataGrid.dataSource.read();
        };
        Import.prototype.validateOneRecord = function (record) {
            var self = this;
            record.Error = "";
            if (!record.Number) {
                record.Error = "Phone number is required";
                return false;
            }
            var regularExpression = /^[a-zA-Z0-9]+$/;
            var valid = regularExpression.test(record.Number);
            if (!valid) {
                record.Error = "Phone number - digits and characters are allowed only";
                return false;
            }
            if (!self.editModel().CreateStatusIfNotExist()) {
                var availableStatus = ko.utils.arrayFirst(self.filteredStatuses(), function (status) {
                    return status.Text === record.Status;
                });
                if (!availableStatus) {
                    record.Error = "Record will not import because Status not available";
                    return false;
                }
            }
            if (!self.editModel().CreateProviderIfNotExist()) {
                var availableProvider = ko.utils.arrayFirst(self.lookupLists.PhoneProviders, function (provider) {
                    return provider.Text === record.Provider;
                });
                if (!availableProvider) {
                    record.Error = "Record will not import because Provider not available";
                    return false;
                }
            }
            if (!self.editModel().CreateTypeIfNotExist()) {
                var availableTypes = ko.utils.arrayFirst(self.lookupLists.PhoneTypes, function (type) {
                    return type.Text === record.PhoneType;
                });
                if (!availableTypes) {
                    record.Error = "Record will not import because Phone Type not available";
                    return false;
                }
            }
            if (!self.editModel().CreateOfficeLocationIfNotExist()) {
                if (record.OfficeAddress && self.officeLocations) {
                    var availableLocation = ko.utils.arrayFirst(self.officeLocations, function (provider) {
                        return provider.Text === record.OfficeAddress;
                    });
                    if (!availableLocation) {
                        record.Error = "Record will not import because Office Location not available";
                        return false;
                    }
                }
            }
            if ("BVN" === record.Provider && !record.BTN) {
                record.Error = "Please enter BTN number";
                return false;
            }
            return true;
        };
        Import.prototype.addNewRecord = function (record) {
            var self = this;
            var dataRow = ko.utils.arrayFirst(self.importData, function (item) { return item.Number === record.Number; });
            if (dataRow) {
                // update row with new values
                dataRow.Status = record.Status !== undefined ? record.Status : dataRow.Status;
                dataRow.Provider = record.Provider !== undefined ? record.Provider : dataRow.Provider;
                dataRow.PhoneType = record.PhoneType !== undefined ? record.PhoneType : dataRow.PhoneType;
                dataRow.BTN = record.BTN !== undefined ? record.BTN : dataRow.BTN;
                dataRow.Comment = record.Comment !== undefined ? record.Comment : dataRow.Comment;
                dataRow.OfficeAddress = record.OfficeAddress !== undefined ? record.OfficeAddress : dataRow.OfficeAddress;
                self.validateOneRecord(record);
            }
            else {
                record.Status = record.Status || "";
                record.Provider = record.Provider || "";
                record.PhoneType = record.PhoneType || "";
                record.BTN = record.BTN || "";
                record.Comment = record.Comment || "";
                record.OfficeAddress = record.OfficeAddress || "";
                self.validateOneRecord(record);
                // add a new item in the grid
                self.importData.push(record);
            }
        };
        Import.prototype.processNumbersImport = function (btn, modal, callback) {
            var self = this;
            self.hasResults(false);
            var data = {
                customerId: self.editModel().CustomerId(),
                createStatusIfNotExist: self.editModel().CreateStatusIfNotExist(),
                createProviderIfNotExist: self.editModel().CreateProviderIfNotExist(),
                createTypeIfNotExist: self.editModel().CreateTypeIfNotExist(),
                createOfficeLocationIfNotExist: self.editModel().CreateOfficeLocationIfNotExist(),
                jsonData: ko.toJSON(self.importData)
            };
            tools.ajaxPost({
                url: "/Import/ImportPhoneNumbers",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    self.resulModel(ko.mapping.fromJS(result.Data, {}));
                    if (callback) {
                        callback();
                    }
                }
                else {
                    tools.error(result.Error);
                }
                self.hasResults(result.Success);
                log.log(result);
            }).always(function () {
                $(btn).button("reset");
                self.importFinished(true);
            });
        };
        return Import;
    }());
    return Import;
});
//# sourceMappingURL=import.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/import/import.js
// module id = 80
// module chunks = 2